import React from 'react'
import { Button } from 'reactstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSave } from '@fortawesome/pro-duotone-svg-icons'
import useBreakpoint from '../../utils/hooks/useBreakpoint'

function SaveButton({ disabled }) {
  const breakpoint = useBreakpoint()
  return (
    <Button
      type="submit"
      color="cpblue-500"
      disabled={disabled}
      className={`${
        breakpoint === 'xs' || breakpoint === 'sm' ? 'w-100' : 'float-end'
      }`}
    >
      <FontAwesomeIcon icon={faSave} /> <span className="ms-2">Save</span>
    </Button>
  )
}

export default SaveButton
